import { BoxOfferValidity, type RecurringPeriod } from "@/modules/boxOffer/entities/boxOfferTypes"
import type { CoachPaymentOfferType } from "@/modules/coachOffers/entities/coachOfferTypes"
import type { CoachOfferPriceDto } from "@/modules/coachOffers/gateway/coachOffersDto"
import type { CoachOfferPricingFormValues } from "@/modules/coachOffers/types/coachOfferFormTypes"
import { PriceObjectEntity } from "@/modules/common/priceObject/entities/priceObjectEntity"
import dayjs from "dayjs"

export class CoachOfferPriceEntity {
  id: string
  price: PriceObjectEntity | null
  recurringPeriod: string | null
  type: CoachPaymentOfferType
  title: string
  count: number | null
  minimumCommitmentPeriod: string | null
  commitmentPeriodAutoRenewal: boolean | null
  validityPeriodMonths: number | null
  creationDate: Date

  constructor(offerPrice: Omit<CoachOfferPriceEntity, "fromEntityToFormValues">) {
    this.id = offerPrice.id
    this.price = offerPrice.price
    this.recurringPeriod = offerPrice.recurringPeriod
    this.type = offerPrice.type
    this.title = offerPrice.title
    this.count = offerPrice.count
    this.minimumCommitmentPeriod = offerPrice.minimumCommitmentPeriod
    this.commitmentPeriodAutoRenewal = offerPrice.commitmentPeriodAutoRenewal
    this.validityPeriodMonths = offerPrice.validityPeriodMonths
    this.creationDate = offerPrice.creationDate
  }

  static fromDto(dto: CoachOfferPriceDto): CoachOfferPriceEntity {
    return new CoachOfferPriceEntity({
      id: dto.id,
      price: dto.price ? PriceObjectEntity.fromDto(dto.price) : null,
      recurringPeriod: dto.recurringPeriod,
      type: dto.type,
      title: dto.title,
      count: dto.count,
      minimumCommitmentPeriod: dto.minimumCommitmentPeriod
        ? dayjs.duration(dto.minimumCommitmentPeriod).months().toString()
        : null,
      commitmentPeriodAutoRenewal: dto.commitmentPeriodAutoRenewal,
      validityPeriodMonths: dto.validityPeriodMonths,
      creationDate: new Date(dto.creationDate),
    })
  }

  fromEntityToFormValues(): CoachOfferPricingFormValues {
    return {
      id: this.id,
      price: this.price ? this.price.value : null,
      recurringPeriod: this.recurringPeriod as RecurringPeriod | null,
      type: this.type,
      title: this.title,
      count: this.count,
      minimumCommitmentPeriod: this.minimumCommitmentPeriod,
      commitmentPeriodAutoRenewal: this.commitmentPeriodAutoRenewal,
      validityPeriodMonths: this.validityPeriodMonths,
      validitySwitch: this.validityPeriodMonths ? BoxOfferValidity.DEFINED : BoxOfferValidity.UNLIMITED,
      displayOrder: null, // This field is not present in CoachOfferPriceEntity, set to null or handle accordingly
      renewable: null, // This field is not present in CoachOfferPriceEntity, set to null or handle accordingly
      isTrialSession: false, // This field is not present in CoachOfferPriceEntity, set to false or handle accordingly
    }
  }
}
